// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"7504247b","354":"67b26ec6"}[chunkId] + ".chunk.js";
};